module.exports = __webpack_public_path__ + "static/media/truck-destination.09513cdd.svg";